import { useInfiniteQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';

import QueryKeys from '../queryKeys';

interface WikiSalaryInfo {
  id: number;
  career: number;
  userName: string;
  salary: number;
  year: number;
}

interface WikiListResponse {
  count: number;
  rows: WikiSalaryInfo[];
}

const getUrl = (companyId: string, category: string, offset: number, limit: number) =>
  `/api/company/${companyId}/salariesWiki?category=${category}&offset=${offset}&limit=${limit}`;

export default function useWikiSalaryList(companyId: string, categoty: string, limit: number = 10) {
  return useInfiniteQuery<WikiListResponse>(
    [QueryKeys.wikiSalaryList, companyId, categoty],
    async ({ pageParam }) => {
      const offset = !pageParam ? 0 : pageParam * limit;
      const data = await fetcher<WikiListResponse>(getUrl(companyId, categoty, offset, limit));

      return {
        ...data,
      };
    },
    {
      enabled: !!companyId,
      staleTime: 60000,
      getNextPageParam: (nextData, pages) => {
        return nextData.rows.length === limit ? pages.length : undefined;
      },
    },
  );
}
